import axios from "axios";
import { includes } from "lodash";
import config from "../../config";
import { getAccessToken } from "../../utils";

const instance = axios.create({
  baseURL: config.BASE_URL,
  timeout: 1000000,
});

const instanceWithNoAuth = axios.create({
  timeout: 60000,
});

// const instanceForImage = axios.create({
//   baseURL: config.BASE_URL,
//   timeout: 60000,
// });

const successStatuses = [200, 201];
const isSuccessful = (responseStatus) =>
  includes(successStatuses, responseStatus);

// Add a request interceptor
instance.interceptors.request.use(
  async (config) => {
    const tokenData = await getAccessToken();
    if (tokenData && !instance.skipToken) {
      config.headers["Authorization"] = `Bearer ${tokenData}`;
    }
    if (!config.headers["Content-Type"]) {
      config.headers["Content-Type"] = "application/json";
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// const getParsedErrorMessage = (error) => {
//   let errorMessage = "";
//   return error;
// };

export const get = (url, config, dispatch) => {
  return new Promise((resolve, reject) => {
    instance
      .get(url, config)
      .then((result) => {
        if (result.status === 200) {
          resolve(result.data);
        } else {
          reject(result.data);
        }
      })
      .catch((error) => {
        //

        reject(error);
      });
  });
};

export const downloadFileContent = (url) => {
  return new Promise((resolve, reject) => {
    axios({
      url: url,
      method: "GET",
      responseType: "blob", // important
      mode: "no-cors",
    })
      .then((response) => {
        resolve(response.data);
        // const url = window.URL.createObjectURL(response.data);
        // const link = document.createElement("a");
        // link.href = url;
        // link.setAttribute("download", name);
        // document.body.appendChild(link);
        // link.click();
      })
      .catch((error) => {
        reject(error);
      });
  });
};

// export const downloadMessagefile = (fileURL, fileType, fileName) => {
//   fetch(fileURL, {
//     method: "GET",
//     headers: {
//       "Content-Type": fileType,
//     },
//   })
//     .then((response) => response.blob())
//     .then((blob) => {
//       // Create blob link to download
//       const url = window.URL.createObjectURL(new Blob([blob]));
//       const link = document.createElement("a");
//       link.href = url;
//       link.setAttribute("download", fileName);
//       // Append to html link element page
//       document.body.appendChild(link);

//       // Start download
//       link.click();

//       // Clean up and remove the link
//       link.parentNode.removeChild(link);
//     });
// };

export const getWithNoAuth = (url, config, dispatch) => {
  return new Promise((resolve, reject) => {
    instanceWithNoAuth
      .get(url, config)
      .then((result) => {
        if (result.status === 200) {
          resolve(result.data);
        } else {
          reject(result.data);
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const post = (url, data, dispatch) => {
  return new Promise((resolve, reject) => {
    instance
      .post(url, data)
      .then((result) => {
        if (isSuccessful(result.status)) {
          resolve(result.data);
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const postImage = (url, data, config, dispatch) => {
  return new Promise((resolve, reject) => {
    instance
      .post(url, data, config)
      .then((result) => {
        if (isSuccessful(result.status)) {
          resolve(result.data);
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const putImage = (url, data, config, dispatch) => {
  return new Promise((resolve, reject) => {
    instance
      .put(url, data, config)
      .then((result) => {
        if (isSuccessful(result.status)) {
          resolve(result.data);
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const uploadFileOnCloud = (url, file, progressCallback) => {
  // return new Promise((resolve, reject) => {

  const config = {
    headers: {
      "Content-Type": "multipart/form-data",
    },
    onUploadProgress: (progressEvent) => {
      if (progressCallback) {
        const { loaded, total } = progressEvent;
        const value = (loaded * 100) / total;
        let precentage = Math.floor(value);
        // if (precentage < 100) {
        //
        progressCallback(precentage);
        // }
      }
    },
  };

  instance
    .post(url, file, config)
    .then((result) => {
      // resolve(result);
    })
    .catch((error) => {
      // reject(error);
    });
  // });
};

export function uploadFile(url, file) {
  // const fileInput = document.getElementById("fileInput");
  // const file = fileInput.files[0];
  // const formData = new FormData();
  // formData.append("file", file);

  axios
    .post(url, file, {
      onUploadProgress: (progressEvent) => {
        let percentComplete = progressEvent.loaded / progressEvent.total;
        percentComplete = parseInt(percentComplete * 100);
      },
    })
    .then((response) => {})
    .catch((error) => {});
}

export const postWithNoToken = (url, data, dispatch) => {
  return new Promise((resolve, reject) => {
    instance
      .post(url, data)
      .then((result) => {
        if (isSuccessful(result.status)) {
          resolve(result.data);
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const put = (url, data, dispatch) => {
  return new Promise((resolve, reject) => {
    instance
      .put(url, data)
      .then((result) => {
        if (result.status === 200) {
          resolve(result.data);
        } else {
          reject(result.data);
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const deleteReq = (url, data, dispatch) => {
  return new Promise((resolve, reject) => {
    instance
      .delete(url, {
        data,
      })
      .then((result) => {
        if (result.status === 200) {
          //
          resolve(result.data);
        } else {
          reject(result.data);
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const patch = (url, data) => {
  return new Promise((resolve, reject) => {
    instance
      .patch(url, data)
      .then((result) => {
        if (result.status === 200) {
          resolve(result.data);
        } else {
          reject(result.data);
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
};
